import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./OpenHomeListTopButtonsAndSearch.scss";
import { commonAction } from "../../../../../redux/features/commonSlice";
import { manageInvitesAction } from "../../../../../redux/features/manageInvitesSlice";
import { CommonEnums } from "../../../../../enums/common.enums";
import SearchIcon from "../../../../../components/icons/SearchIcon";
import ResetIcon from "../../../../../components/icons/ResetIcon";
import ListFilterButton from "../../../buttons/ListFilterButton";

const OpenHomeListTopButtonsAndSearch = ({
  add_btn_name,
  add_btn_link,
  reset_btn_link,
  placeholder = "Search...",
  onChangeSearch,
  value = "",
  type,
  showAddBtn = true,
  showResetBtn = true,
  showFilterBtn = true,
}: {
  add_btn_name?: string;
  add_btn_link?: string;
  reset_btn_link?: string;
  placeholder?: string;
  onChangeSearch?: (value: string) => void;
  value?: string;
  type?: string;
  showAddBtn?: boolean;
  showResetBtn?: boolean;
  showFilterBtn?: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetFilter = () => {
    if (!reset_btn_link) return;
    dispatch(commonAction?.resetFilter());
    dispatch(manageInvitesAction.setInvitesListReset());
    navigate(reset_btn_link, { replace: true });
    if (onChangeSearch) {
      onChangeSearch?.("");
    }
  };

  const onClickInvite = () => {
    dispatch(manageInvitesAction.setInviteDialog());
  };

  const getButton = () => {
    if (!showAddBtn || !add_btn_name) return null;

    switch (type) {
      case CommonEnums.pageTypes?.properties?.key:
        return (
          <Link to={add_btn_link || "#"} className="send-invite-btn">
            {add_btn_name}
          </Link>
        );
      case CommonEnums.pageTypes?.manage_invites?.key:
        return (
          <button className="send-invite-btn" onClick={onClickInvite}>
            {add_btn_name}
          </button>
        );
      default:
        return null;
    }
  };

  return (
    <div className="list-open-buttons-and-search-container">
      <div className="search-contain">
        <div className="search-icon">
          <SearchIcon />
        </div>
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          className="search-input"
          onChange={(e) => onChangeSearch?.(e.target.value)}
        />
      </div>

      <div className="list-top-buttons-container">
        {showResetBtn && reset_btn_link && (
          <button className="list-top-filter-btn" onClick={resetFilter}>
            <div className="filter-icon">
              <ResetIcon />
            </div>
            <p>Reset Filters</p>
          </button>
        )}

        {showFilterBtn && <ListFilterButton />}
        {getButton()}
      </div>
    </div>
  );
};

export default OpenHomeListTopButtonsAndSearch;
